"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var navigation_item_1 = __importDefault(require("./navigation-item"));
var navigation_subnav_1 = __importDefault(require("./navigation-subnav"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var uniqueId_1 = __importDefault(require("../../_helpers/uniqueId"));
var tokens_1 = require("../../tokens");
var Navigation = function (props) {
    return (React.createElement(Navigation.Element, __assign({}, automation_attribute_1.default('navigation'), { "aria-label": props.description, role: "navigation", id: props.id }),
        React.createElement(Navigation.List, __assign({}, automation_attribute_1.default('navigation.group'), props))));
};
Navigation.Element = styled_1.default.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var NavigationGroup = function (_a) {
    var title = _a.title, children = _a.children;
    var id = uniqueId_1.default('navigationgroup');
    return (React.createElement(NavigationGroup.Element, __assign({}, automation_attribute_1.default('navigation.group'), { "aria-labelledby": id }),
        React.createElement(NavigationGroupHeader, { id: id }, title),
        React.createElement("ul", null, children)));
};
NavigationGroup.Element = styled_1.default.section(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  /* background-color: violet; */\n  :not(:last-of-type):not(:only-of-type) {\n    margin-bottom: ", ";\n  }\n"], ["\n  /* background-color: violet; */\n  :not(:last-of-type):not(:only-of-type) {\n    margin-bottom: ", ";\n  }\n"])), tokens_1.spacing.medium);
var NavigationGroupHeader = styled_1.default.h2(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-transform: uppercase;\n  font-size: 12px;\n  color: ", ";\n  letter-spacing: 1px;\n  padding-bottom: ", ";\n"], ["\n  text-transform: uppercase;\n  font-size: 12px;\n  color: ", ";\n  letter-spacing: 1px;\n  padding-bottom: ", ";\n"])), tokens_1.colors.text.secondary, tokens_1.spacing.xxsmall);
Navigation.List = styled_1.default.ul(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
Navigation.Item = navigation_item_1.default;
Navigation.Group = NavigationGroup;
Navigation.Subnav = navigation_subnav_1.default;
Navigation.GroupHeader = NavigationGroupHeader;
Navigation.defaultProps = {};
exports.default = Navigation;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=navigation.js.map